import { FunctionComponent, useEffect, useState } from 'react'
import WorkroomDescription from './WorkroomDescription'
import WorkroomPostsOverview from './Posts/WorkroomPostsOverview'
import WorkroomDocuments from './WorkroomDocuments'
import WorkroomMembers from './WorkroomMembers'
import { getMyWorkroomPermissions } from 'Frontend/scripts/services/workrooms.service'
import { IWorkroomUserPermissions } from 'Frontend/scripts/models/workrooms.model'
import { WorkroomProvider } from './Partials/WorkroomContext'
import { Tab, Tabs } from 'react-bootstrap'
import useQueryParams from 'Frontend/hooks/useQueryParams'
import { useTranslation } from 'react-i18next'

interface WorkroomProps {
  workroomName: string
  listingUrl: string
  isHidden: string
}

const workroomTypes = ['description', 'posts', 'documents', 'members']

const Workroom: FunctionComponent<WorkroomProps> = ({ workroomName, listingUrl, isHidden }) => {
  const { t } = useTranslation()
  const { setQueryParam, getQueryParam, removeQueryParam } = useQueryParams()
  const [activeType, setActiveType] = useState<string>(getQueryParam('type') || workroomTypes[0])

  const [name, setName] = useState<string>(workroomName)
  const [permissions, setPermissions] = useState<IWorkroomUserPermissions>()
  const id = parseInt(getQueryParam('id') as string)

  useEffect(() => {
    getMyWorkroomPermissions(id).then((permissions) => {
      setPermissions(permissions)
    })
  }, [])

  const renderWorkroomTypeComponent = (type: string) => {
    switch (type) {
      case 'description':
        return (
          <WorkroomDescription
            id={id}
            workroomListingUrl={listingUrl}
            permissions={permissions}
            callback={(name: string) => setName(name)}
          />
        )
      case 'posts':
        return <WorkroomPostsOverview id={id} permissions={permissions} />
      case 'documents':
        return (
          <WorkroomProvider>
            <WorkroomDocuments id={id} />
          </WorkroomProvider>
        )
      case 'members':
        return <WorkroomMembers id={id} permissions={permissions} />
    }
  }

  const getTabTitle = (activeTabName: string) => {
    switch (activeTabName) {
      case 'description':
        return 'Beskrivning'
      case 'posts':
        return 'Inlägg'
      case 'documents':
        return 'Dokument'
      case 'members':
      default:
        return 'Medlemmar'
    }
  }

  const onTabChanged = (type: string | null) => {
    if (!type) return

    setActiveType(type)
    if (type !== 'posts') {
      removeQueryParam('postId')
      removeQueryParam('postType')
      removeQueryParam('page')
    }
    setQueryParam('type', type.toString())
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="mb-0">{name}</h1>
        {isHidden == 'True' && <span className="badge workrooms__status">{t('hidden')}</span>}
      </div>
      <Tabs defaultActiveKey={activeType} transition={false} className="mt-5 mb-3" onSelect={onTabChanged} fill>
        {workroomTypes.map((type) => (
          <Tab eventKey={type} title={getTabTitle(type)} key={type}>
            {renderWorkroomTypeComponent(type)}
          </Tab>
        ))}
      </Tabs>
    </>
  )
}
export default Workroom
